import React from 'react';
import styled from 'styled-components';

import MetricsInfoPopupContext from 'contexts/MetricsInfoPopupContext';
import InfoHeading from 'components/MetricsInfoButton/MetricInfoPopup/InfoHeading';
import MetricInformation from 'components/MetricsInfoButton/MetricInfoPopup/MetricInformation';
import metricTypeCheckers from 'types/metricTypeCheckers';

const buildMetricInfo = (
  metric: Metrics.Metric,
): MetricsInfoButton.NormalMetricInfo => ({
  type: 'NormalMetricInfo',
  key: metric.id,
  metric,
  isDefaultFiltersDisabled: false,
});

const noop = () => {};

const TooltipWrapper = styled.div`
  background: var(--color-bg-primary);
  border-radius: 8px;
  border: 1px solid var(--color-border-tertiary);
  box-shadow: var(--shadow-md);
  padding: 16px;
  max-width: 400px;
`;

/**
 * Describes how a metric is defined. Intended as the content of an
 * `isUnstyledTooltip` Tooltip.
 *
 * Compound metric inputs are resolved through CompoundMetricsContext, so
 * callers must ensure the inputs are available there.
 */
const MetricDefinitionTooltip = ({ metric }: { metric: Metrics.Metric }) => {
  const metricInfo = buildMetricInfo(metric);

  return (
    <MetricsInfoPopupContext.Provider value={{ vis: metric }}>
      <TooltipWrapper>
        {metricTypeCheckers.isCompoundMetric(metric) && (
          <div style={{ marginBottom: 12 }}>
            <InfoHeading
              metricInfo={metricInfo}
              close={noop}
              hideClose
              hideLinks
            />
          </div>
        )}
        <MetricInformation metricInfo={metricInfo} hideLinks />
      </TooltipWrapper>
    </MetricsInfoPopupContext.Provider>
  );
};

export default MetricDefinitionTooltip;
